import {UI} from "../../../stemjs/src/ui/UIBase.js";


export class CheckerEditor extends UI.Element {
    render() {
        return <h1>Checker editor</h1>;
    }
}
